
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
    },
    computed: {
        percentValue(): number {
            return this.valueToPercent(this.modelValue);
        },
    },
    methods: {
        valueToPercent(value: number): number {
            return Math.min(100, ((value - this.min) / this.max) * 100);
        },
        percentToValue(percent: number): number {
            return this.min + ((this.max - this.min) * percent) / 100;
        },
        handleWheel(evt: WheelEvent) {
            const increase = -evt.deltaY;
            const newPercent = Math.max(
                0,
                Math.min(100, this.percentValue + increase)
            );
            const newValue = this.percentToValue(newPercent);

            this.$emit('update:modelValue', newValue);
        },
        handleMouse(evt: MouseEvent) {
            if (evt.buttons === 1) {
                const elRect = this.$el.getBoundingClientRect();
                const clickPercent =
                    ((evt.clientX - elRect.x) / elRect.width) * 100;
                const boundedPercent = Math.round(
                    Math.max(0, Math.min(100, clickPercent))
                );
                this.$emit(
                    'update:modelValue',
                    this.percentToValue(boundedPercent)
                );
            }
        },
    },
});
